import { Link as ScrollLink } from 'react-scroll';
import styled from 'styled-components';
import { Title } from 'components';
import { px2rem } from 'src/util';
import GreenChevron from 'assets/green-chevron.svg';
import CloseAccordion from 'assets/close-accordion.svg';
import OpenAccordion from 'assets/open-accordion.svg';

export const Wrapper = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 998px) {
    padding: ${px2rem(160)} ${px2rem(40)};
  }

  @media screen and (max-width: 997px) {
    padding: 120px 20px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${px2rem(1110)};
  width: 100%;

  .rc-collapse-anim-active {
    transition: height 0.2s ease-out;
  }

  .rc-collapse-content-inactive {
    display: none;
  }

  div.rc-collapse-item {
    border-bottom: 1px solid #ced4da;
    position: relative;
    transition: box-shadow 0.3s;

    &:not(:last-of-type) {
      /* &::after {
        background-color: #ced4da;
        content: '';
        display: block;
        height: 1px;
        left: 0;
        position: absolute;
        top: 100%;
        width: 100%;
      } */
    }

    &.rc-collapse-item-active {
      box-shadow: ${px2rem(10)} ${px2rem(14)} ${px2rem(44)} rgba(0, 0, 0, 0.06);

      .rc-collapse-header {
        background-image: url(${CloseAccordion});
      }
    }
  }

  .rc-collapse-header {
    background: url(${OpenAccordion}) center right ${px2rem(40)} / ${px2rem(17)}
      no-repeat;
    cursor: pointer;
  }

  .rc-collapse-content {
    overflow: hidden;
    position: relative;
    top: -20px;
  }

  @media screen and (min-width: 1441px) {
    grid-column: 2 / span 14;
  }

  @media screen and (max-width: 1440px) and (min-width: 998px) {
    grid-column: 1 / span 16;
  }

  @media screen and (min-width: 998px) {
    .rc-collapse-header {
      padding: ${px2rem(40)};
    }
  }

  @media screen and (max-width: 997px) {
    .rc-collapse-header {
      background-position: center right 20px;
      padding: 20px 40px 20px 20px;
    }
  }
`;

export const StyledTitle = styled(Title)`
  text-align: center;

  @media screen and (min-width: 998px) {
    margin-bottom: ${px2rem(80)};
  }

  @media screen and (max-width: 997px) {
    font-size: 32px;
    margin-bottom: 10px;
  }
`;

export const AccordionHeader = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

export const AccordionTitle = styled.h3`
  color: #2e3740;
  font-family: 'Univia Pro', 'Arial', 'sans-serif';
  font-size: ${px2rem(20)};
  letter-spacing: -0.045em;
  line-height: 120%;
`;

export const AccordionContent = styled.div`
  line-height: 150%;

  @media screen and (min-width: 998px) {
    font-size: ${px2rem(18)};
    padding: 0 ${px2rem(40)} ${px2rem(20)};
  }

  @media screen and (max-width: 997px) {
    font-size: 14px;
    padding: 0 20px 20px;
  }
`;

export const GreenLink = styled.a`
  align-self: flex-start;
  color: #21aa91;

  strong {
    display: inline-block;
    font-weight: 700;
    text-decoration: underline;
  }

  @media screen and (min-width: 998px) {
    align-items: center;
    display: flex;
    font-size: ${px2rem(20)};
    margin-top: ${px2rem(56)};

    strong {
      margin-left: ${px2rem(5)};
    }

    &::after {
      content: url(${GreenChevron});
      height: 50%;
      line-height: 0;
      margin-left: ${px2rem(16)};
    }
  }

  @media screen and (max-width: 997px) {
    font-size: 16px;
    margin-top: 48px;
  }
`;
